import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
import { fontSize } from '../allhomes-listing-map-search.style';
export var marker = {
  name: "1oc4226",
  styles: "background:none;outline:none;border:0;position:absolute;top:50%;left:50%;user-select:none;transform:translate(-50%,-50%);transition:all 0.1s ease-in-out;cursor:pointer;&:hover{z-index:1;transform:scale(1.5);top:-15px;left:-10px;}"
};
export var mapMarkerIcon = {
  name: "h9w276",
  styles: "width:18px;height:26px;stroke-linejoin:round;stroke-linecap:round;vertical-align:middle;fill:none;"
};
export var markerLabel = /*#__PURE__*/css("width:16px;height:17px;color:", variables.colour.neutral700, ";border:1px solid ", variables.colour.neutral300, ";border-radius:50%;background:", variables.colour.white, ";font-family:", variables.font.bodyFontFamily, ";font-size:", fontSize, ";text-align:center;position:absolute;top:-7px;right:-8px;user-select:none;");